/**
 * MemoryCardIcon/index.js
 * desc: memory card icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const MemoryCardIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="memory-card icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.memoryCard.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 0h8c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V6l6-6zm0 6h2V2H6v4zm5 0H9V2h2v4zm1 0h2V2h-2v4z" /></svg>
    </IconButton>
);


export default MemoryCardIcon;
